"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemChooserValueList = void 0;
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const react_1 = __importStar(require("react"));
const ValueList_1 = __importDefault(require("../core/ValueList"));
exports.ItemChooserValueList = react_1.default.forwardRef((props, ref) => {
    const canDelete = !props.required || (props.required && props.value.length > 1);
    const handleClickDelete = (0, react_1.useCallback)(item => () => { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, props.value.filter(s => s.id !== item.id)); }, [props]);
    const renderValue = (0, react_1.useMemo)(() => (item, idx) => (react_1.default.createElement(DataPill_1.default, { style: { cursor: 'pointer', marginRight: 4 }, large: true, key: idx || item.id, type: props.type || item.type || item.__typename, avatarUrl: item.avatarUrl, id: item.id, value: item.title, onDelete: canDelete ? handleClickDelete(item) : undefined })), [canDelete, handleClickDelete, props.type]);
    const renderAll = (0, react_1.useMemo)(() => () => (react_1.default.createElement(DataPill_1.default, { style: { cursor: 'pointer' }, large: true, type: props.type || undefined, value: props.allSelectedLabel, onDelete: canDelete ? props.onRemoveAllSelected : undefined })), [canDelete, props]);
    return react_1.default.createElement(ValueList_1.default, Object.assign({}, props, { ref: ref, renderValue: renderValue, renderAll: renderAll }));
});
exports.default = exports.ItemChooserValueList;
